'use client'
import { useSnackbar } from '@/contexts/SnackbarContext'
import { Product } from '@/types'
import { Card, CardBody, CardFooter, CheckboxGroup, Checkbox, Divider, Button } from '@nextui-org/react'
import React from 'react'

const PremixPack = ({
    pack,
    handlePack,
    selected,
    setSelected,
    product,
    myProducts,
    is1kg
}: {
    pack: number,
    handlePack: (pack: number) => void,
    selected: string[],
    setSelected: React.Dispatch<React.SetStateAction<string[]>>,
    product: Product,
    myProducts: Product[],
    is1kg: boolean
}) => {
    const { showSnackbar } = useSnackbar()
    const [products, setProducts] = React.useState<Product[]>(myProducts)
    const increaseQuantity = (id: string) => {
        if (selected.length >= pack) return
        setSelected((prev) => [...prev, id])
    }
    const getProductCount = (selected: string[], toCheck: string) => {
        return selected.filter((sel) => {
            return sel == toCheck
        }).length
    }
    const decreaseQuantity = (id: string) => {
        if (id == product.id && getProductCount(selected, id) == 1) {
            showSnackbar(3000, 3, "Please use choose different product dropdown at the top to change product.")
            return;
        } else if (getProductCount(selected, id) == 1) {
            setSelected((prev) => prev.filter((sel) => sel != id) as string[]);
        } else {
            setSelected((prev) => {
                let flag = false;
                return prev.filter((sel) => {
                    if (sel == id && !flag) {
                        flag = true;
                        return false;
                    }
                    return true;
                }) as string[];
            }
            );
        }
    };


    return (
        <>
            <div className="flex justify-start items-start gap-4 flex-wrap">
                <button onClick={() => handlePack(2)} className={`flex-grow ${pack == 2 ? "pointer-events-none" : "opacity-60"}`}>
                    <Card style={{
                        background: `${pack != 2 ? "linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5))," : ""} url('/images/packbg.png') center/cover`
                    }} className={`hover:bg-gray-50 cursor-pointer shadow-none ${pack == 2 ? "outline-[#000000] outline-offset-0" : ""} overflow-visible bg-gradient-to-b from-[#00000090] to-[#00000090] bg-center bg-cover text-white`} shadow='none'>
                        <CardBody className='px-8 py-4 items-center'>
                            <p className='text-lg'>Pack of</p>
                            <p className='text-3xl'>2</p>
                        </CardBody>
                        <CardFooter className='text-white text-center flex justify-center bg-amber-400'>
                            Regular
                        </CardFooter>
                    </Card>
                </button>
                <button onClick={() => handlePack(4)} className={`flex-grow ${pack == 4 ? "pointer-events-none" : "opacity-60"}`}>
                    <Card style={{
                        background: `${pack != 4 ? "linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5))," : ""} url('/images/packbg.png') center/cover`
                    }} className={`hover:bg-gray-50 cursor-pointer shadow-none ${pack == 4 ? "outline-[#000000] outline-offset-0" : ""} overflow-visible bg-gradient-to-b from-[#00000090] to-[#00000090] bg-center bg-cover text-white`} shadow='none'>
                        <CardBody className='px-8 py-4 items-center'>
                            <p className='text-lg'>Pack of</p>
                            <p className='text-3xl'>4</p>
                        </CardBody>
                        <CardFooter className='text-white text-center flex justify-center bg-[#afd72b]'>
                            Top Seller
                        </CardFooter>
                    </Card>
                </button>
                <button onClick={() => handlePack(6)} className={`flex-grow ${pack == 6 ? "pointer-events-none" : "opacity-60"}`}>
                    <Card style={{
                        background: `${pack != 6 ? "linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5))," : ""} url('/images/packbg.png') center/cover`
                    }} className={`hover:bg-gray-50 cursor-pointer shadow-none ${pack == 6 ? "outline-[#000000] outline-offset-0" : ""} overflow-visible bg-gradient-to-b from-[#00000090] to-[#00000090] bg-center bg-cover text-white`} shadow='none'>
                        <CardBody className='px-8 py-4 items-center'>
                            <p className='text-lg'>Pack of</p>
                            <p className='text-3xl'>6</p>
                        </CardBody>
                        <CardFooter className='text-white text-center flex justify-center bg-blue-400'>
                            Value Pack
                        </CardFooter>
                    </Card>
                </button>
                <div
                    className='grid grid-cols-2 w-full max-w-full gap-6'
                >

                    {products.map((p: Product) => {
                        if (p.category === "Premix" && p.isactive == 1) {
                            const isSelected = selected.includes(`${p.id}`);
                            const isOutOfStock = (is1kg ? p.outofstock1kg === 1 : p.outofstock === 1);

                            return (
                                <div
                                    key={p.id}
                                    className={`flex flex-col gap-2 bg-amber-50 p-2 rounded-lg ${isSelected ? "outline-1 outline-amber-500 outline" : ""} ${p.id == product.id ? "outline-2 bg-amber-100" : ""} ${isOutOfStock ? "opacity-70" : ""}`}
                                >
                                    <p className={`${isSelected ? "font-semibold" : ""} text-center`}>
                                        {p.englishname} {p.type === "unsweetened" ? "(Unsweetened)" : "(Low sugar)"}
                                    </p>
                                    <div className="flex w-full justify-between">
                                        <button
                                            className='w-8 h-8 bg-white rounded-full shadow-sm items-center flex justify-center disabled:opacity-50 disabled:cursor-default'
                                            onClick={() => decreaseQuantity(`${p.id}`)}
                                            disabled={!isSelected || isOutOfStock || (!p.price1kg && is1kg)} // Disable if not selected or out of stock
                                        >
                                            -
                                        </button>
                                        {isOutOfStock ? (
                                            <p className='text-center font-medium text-md text-slate-700'>Out of stock</p>
                                        ) : (
                                            isSelected ? (
                                                <p className='text-center font-semibold text-lg text-slate-900'>
                                                    {getProductCount(selected, `${p.id}`)}
                                                </p>
                                            ) : (
                                                <p className='text-center font-medium text-md text-slate-700'>0</p>
                                            )
                                        )}
                                        <button
                                            className='w-8 h-8 bg-white rounded-full shadow-sm items-center flex justify-center disabled:opacity-50 disabled:cursor-default'
                                            onClick={() => increaseQuantity(`${p.id}`)}
                                            disabled={selected.length >= pack || isOutOfStock || (!p.price1kg && is1kg)} // Disable if pack limit reached or out of stock
                                        >
                                            +
                                        </button>
                                    </div>
                                </div>
                            );
                        }
                        return null;
                    })}

                </div>
            </div >
            <Divider />
            <div className="flex flex-col">
                <p className='text-lg font-semibold mb-4'
                >Shopping cart ({selected.length})</p>
                {
                    (Array.from(new Set(selected))).map((id) => {
                        const selectedProduct = products.find((p: Product) => p.id == id.toString());

                        if (selectedProduct) {
                            return (
                                <div key={selectedProduct.id} className='flex justify-between items-center'>
                                    <p className='text-gray-500'>{selectedProduct.englishname} {selectedProduct.type}</p>
                                    <p className='text-gray-500'>$ {
                                        !is1kg ? selectedProduct.price : selectedProduct.price1kg
                                    } x {
                                            getProductCount(selected, selectedProduct.id.toString())
                                        }</p>
                                </div>
                            );
                        }
                        else {
                            return null;
                        }
                    })
                }
            </div>
            <Divider />
        </>
    )
}

export default PremixPack